<script setup lang="ts">
import { LOCAL_STORAGE_KEYS } from "@/constants/storageKeys";
import { useJoinStore } from "@/store";
import { localize } from "@/utils";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const { member } = useJoinStore();
const router = useRouter();

const route = useRoute();
const role = computed(() => route.params.role);

const welcomeMessage = computed(() => {
  switch (role.value) {
    case "players":
      return localize("R2 Player가 되신 것을 환영합니다.")
    case "centers":
      return localize("R2 Center가 되신 것을 환영합니다.")
    case "planners":
      return localize("R2 Planner가 되신 것을 환영합니다.")
  }
});

const partnerWebUrl = import.meta.env.VITE_PARTNER_WEB_URL;
const lang = ref(localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE) || 'en-US');

const handleLogin = () => {
  if (role.value === "players") {
    router.push("/home/login");
  } else {
    window.open(`${partnerWebUrl}/#/${lang.value === 'ko-KR' ? 'ko' : 'en'}/login`, "_blank");
  }
};

const loginButtonText = computed(() => {
  if (role.value === "players") {
    return localize("로그인");
  }
  return localize("파트너 웹 로그인");
});

// onBeforeRouteLeave(blockPage(`/home/join/optional/${role.value}`));
</script>

<template>
  <div class="join-box">
    <div class="progress-line">
      <div class="line" style="width: 100%"></div>
    </div>
    <div class="step-wrap">
      <b>STEP 5</b>
      <h2>{{ localize("회원가입 완료") }}</h2>
    </div>
    <div class="welcome">
      <img src="@/assets/home/img/icon-join-complete.png" alt="" />
      <!-- <p>{{ localize("R2 Player가 되신 것을 환영합니다.") }}</p> -->
      <p>{{ welcomeMessage }}</p>
    </div>
    <div class="bx-purple">
      <b>{{ member.emailAddress }}</b
      ><br/>
      {{ localize("로그인하시면 서비스를 이용하실 수 있습니다.") }}
    </div>
    <div class="btn-wrap">
      <!-- <router-link to="/home/login" class="btn btn-primary center w-100">{{ localize("로그인") }}</router-link> -->
        <button class="btn btn-primary center w-100" @click="handleLogin">
          {{ loginButtonText }}
        </button>
    </div>
  </div>
</template>

<style scoped></style>
